import React from 'react'
import {locale as Arabic} from './ar';
import {locale as English} from './en';
import {locale as Hebrew} from './he';

export const AppLocales = {
    ar: Arabic,
    en: English,
    he: Hebrew,
}
export const AppLanguages = [
    {
        code: 'en',
        short_name: 'En',
        dir: 'ltr',
        is_rtl: false,
        is_active: false,
    },
    {
        code: 'he',
        short_name: 'He',
        dir: 'rtl',
        is_rtl: true,
        is_active: true,
    },
    {
        code: 'ar',
        short_name: 'Ar',
        dir: 'rtl',
        is_rtl: true,
        is_active: true,
    }

];
export const setLocale = (locale) => {
    localStorage.setItem('app_locale', locale);
}
export const getLocale = () => {
    let lang = localStorage.getItem('app_locale');
    if (!lang || lang === null) {
        lang = 'he';
    }
    const locale = AppLanguages.filter(l => l.code === lang)[0];
    return locale;
}

export const locale = AppLocales[getLocale().code]